import * as React from 'react'
import  { useState } from 'react'
import { Link, useIntl } from 'gatsby-plugin-react-intl'
import { animated, useTransition } from 'react-spring'
import {menuScrollHandler} from 'services/menuScrollHandler'
import Logo from '../../../images/logo_menu.svg'
import Burger from 'react-css-burger'
import { TemperatureUnitPicker } from './TemperatureUnitPicker'


export const MobileNav = () => {
    const [menuOpen, setMenuOpen] = useState(false)
    const [searchOpen, setSearchOpen] = useState(false)
    const [lastScroll, setLastScroll] = React.useState(0)
    const [isHover, setIsHovered] = React.useState(false)

    const transitionEffect = {
        from: { opacity: 0, left: 780 },
        enter: { opacity: 1, left: 0 },
        leave: { opacity: 0, left: 780 },
        config: { duration: 500 },
    }

    const slideIntoView = useTransition(menuOpen, transitionEffect)
    const slideSearchIntoView = useTransition(searchOpen, transitionEffect)
    const intl = useIntl()
    let classTransitionTimeout: any = null;
    const handleOpenCloseMenu = () => {
        if(searchOpen) {setSearchOpen(false)
        }
        let root = document.getElementsByTagName('html')[0];
        
        setMenuOpen(prev => !prev)
    }

    const handleOpenCloseSearch = () => {
        
        if (menuOpen) {
            setMenuOpen(false)
        }
        else {

        }
        //setSearchOpen(prev => !prev)
    }
    

    React.useEffect(() => {
        if (menuOpen) {
            const header = document.querySelector('.header');
            if (header?.classList.contains('header--hidden')) header?.classList.remove('header--hidden');
            return;
        }

        const handler = () => {
            menuScrollHandler(isHover, lastScroll, setLastScroll);
        }

        document.addEventListener('scroll', handler)

        return () => {
            document.removeEventListener('scroll', handler)
        }

    }, [isHover, lastScroll,menuOpen])

    return (
        <>
            <div className="header mobile">
                <div className="header__applogo mobile">
                    <Link to="/">
                        <span className="header__applogo--image mobile">
                            <img src={Logo} alt="Sunheron logo" />
                        </span>
                        <p className="header__applogo--text mobile">Sunheron</p>
                    </Link>
                    
                </div>
                <div className="header__main_nav--holder mobile">
                    {/* <div className="header__button--wrapper mobile">
                        <button
                            aria-label="Vyhledejte lokalitu"
                            className={`header__button mobile ${searchOpen && 'active'}`}
                            onClick={handleOpenCloseSearch}
                        >
                            <img
                                src={searchOpen ? SearchWhite : SearchDark}
                                alt="Vyhledejte lokalitu"
                                className="header__button--search--image mobile"
                            />
                        </button>
                    </div> */}
                    <div className="header__button--wrapper header__button--image mobile">
                        <Burger
                            onClick={handleOpenCloseMenu}
                            active={menuOpen}
                            burger="collapse"
                            scale={0.5}
                            marginTop={'0'}
                            marginLeft={'0'}
                        />
                        <span className="header__button--text mobile">
                            {intl.formatMessage({id:'common.menu'}).toUpperCase()}
                        </span>
                    </div>
                </div>
            </div>
            {slideIntoView(
                (styles, showMenu) =>
                    showMenu && (
                        <animated.menu className="nav--mobile" style={styles}>
                            {/* <li className="nav__item--mobile">
                                <Link to="/">{intl.formatMessage({id: 'header.howThingsWork'})}</Link>
                            </li> */}
                            <li className="nav__item--mobile">
                                <Link to="/about-us/">{intl.formatMessage({id: 'header.aboutSunheron'})}</Link>
                            </li>
                            <li className="nav__item--mobile">
                                <Link to="/faq/">FAQ</Link>
                            </li>
                            <li className="nav__item--mobile">
                                <Link to="/contact/">{intl.formatMessage({id: 'header.contact'})}</Link>
                            </li>
                            <TemperatureUnitPicker />
                            {/* <hr className="hr--m2" />
                            <div className="text--center">
                                <Link to="/">
                                    <button className="text--uppercase button button--primary button__text--thin m--auto w100">
                                        Přejít na vyhledávač dovolené
                                    </button>
                                </Link>
                            </div> */}
                        </animated.menu>
                    )
            )}
            {/* {slideSearchIntoView((styles, showSearch) => showSearch && (<animated.div style={styles} className="nav--mobile">
                <div className="text--center mt20 header__search__input--wrapper">
                    <input type="text" placeholder="Kam chcete vyrazit?" className="header__mobile__input--search"/>
                    <Link to="/vyhledavani" className="fp__form__link">
                        <span>Podrobné filtrování</span>
                        <span className="fp__form__link--toggle">
                            <ToggleButton onClick={()=>{}} classNames="ml10 rotate270"/>
                        </span>
                    </Link>
                </div>
            </animated.div>))} */}
        </>
    )
}
